// extracted by mini-css-extract-plugin
export default {"editIcon":"BillingHistoryTable_editIcon__5KM09"};